import { useQuery } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { MeetingScope } from 'src/meetings/scope';
import type { CalendarEvent } from 'src/meetings/models';

export type FamilyMeeting = CalendarEvent;

function meetingsResource(scope: MeetingScope): string {
  return scope.kind === 'family'
    ? `families/${scope.familyId}/calendar-events`
    : `clients/${scope.clientId}/calendar-events`;
}

export function meetingsQueryKey(scope: MeetingScope): readonly unknown[] {
  return scope.kind === 'family'
    ? ['families', scope.familyId, 'calendar-events']
    : ['clients', scope.clientId, 'calendar-events'];
}

export const useScopedMeetings = (scope: MeetingScope) => {
  const resource = meetingsResource(scope);

  const { data, isLoading, error } = useQuery({
    queryKey: meetingsQueryKey(scope),
    queryFn: () => api.getPaginated<FamilyMeeting>(resource, { page: 1, size: 100 }),
  });

  return {
    events: data?.items ?? [],
    isLoading,
    error,
  };
};
